import { t } from 'i18next';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import InputTranslateButton from 'components/desktop/_general/Input/InputExtensions/InputTranslateButton/InputTranslateButton';
import SimpleInput from 'components/desktop/_general/Input/SimpleInput/SimpleInput';
import useCultureCode from 'hooks/redux/useCultureCode';
import useLanguages from 'hooks/redux/useLanguages';
import { usePermissions } from 'hooks/usePermissions';
import { Language } from 'types/Language/Language';

interface IProps {
	handleNamePluralChange: (input: string) => void;
	handleNameSingularChange: (input: string) => void;
	namePlural: string;
	nameSingular: string;
	onTranslateNamePluralClick: (input: string) => void;
	onTranslateNameSingularClick: (input: string) => void;
	selectedLanguage: string;
}

const AccessoryLanguageInput = (props: IProps) => {
	const { isAccessoryEditor } = usePermissions();
	const reduxLanguages: Language[] = useLanguages();
	const reduxCultureCode: string = useCultureCode();

	const isTranslatable = (): boolean => {
		if (!isAccessoryEditor) return false;
		if (reduxLanguages && reduxCultureCode !== undefined) {
			if (reduxCultureCode === props.selectedLanguage) {
				return false;
			} else {
				return true;
			}
		}
		return false;
	};

	return (
		<>
			<div className="row mt-2">
				<div className="col-12">
					<b>{t('_general:SINGULAR')}</b>
					<br />
					<label>{t('_general:NAME')}</label>
					<div className="input-group">
						<SimpleInput
							disabled={!isAccessoryEditor}
							errorKey="NameSingularTranslations"
							handleChange={props.handleNameSingularChange}
							value={props.nameSingular}
						/>
						<RenderIf condition={isTranslatable()}>
							<InputTranslateButton
								name="nameSingularTranslations"
								onClick={props.onTranslateNameSingularClick}
							/>
						</RenderIf>
					</div>
				</div>
			</div>
			<br />
			<div className="row">
				<div className="col-12">
					<b>{t('_general:PLURAL')}</b>
					<br />
					<label>{t('_general:NAME')}</label>
					<div className="input-group">
						<SimpleInput
							disabled={!isAccessoryEditor}
							errorKey={'NamePluralTranslations'}
							handleChange={props.handleNamePluralChange}
							value={props.namePlural}
						/>
						<RenderIf condition={isTranslatable()}>
							<InputTranslateButton
								name="nameSingularTranslations"
								onClick={props.onTranslateNamePluralClick}
							/>
						</RenderIf>
					</div>
				</div>
			</div>
		</>
	);
};

export default AccessoryLanguageInput;
